import { FC, useState } from 'react';
import toast from 'react-hot-toast';
import { IHookApiResponse } from '../../hooks/IHookApiResponse';
import { useHandleField } from '../../hooks/useHandleField';
import { INewRole, IRoleGoup } from '../../model/IRole';
import { msg } from '../../msg';
import { IZodErrorsState } from '../../utils/checkFormStateByZod';
import TextButtom from '../common/buttom/TextButtom';
import Modal from '../common/Modal';
import RoleItemForm from './RoleItemForm';

const initNewRoleForm: INewRole = {
  id: undefined,
  name: '',
  description: '',
  ticketTypes: '',
  systemRole: "agent"
}

const AddRoleLink: FC<{
  title: string,
  systemRole: IRoleGoup,
  addRole: (data: INewRole) => IHookApiResponse<INewRole>,
}> = ({ title, addRole, systemRole }) => {

  const [isModal, setIsModal] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [form, setForm] = useState<INewRole>({ ...initNewRoleForm, systemRole });
  const [errState, setErrState] = useState<Partial<IZodErrorsState<INewRole>>>();

  const handle = useHandleField(setForm);

  const clearState = () => {
    setErrState(() => undefined);
    setForm({
      ...initNewRoleForm,
      systemRole
    });
  }

  const handleAddRole = async () => {
    setErrState(() => undefined);
    setIsPending(() => true);
    const response = await addRole(form);
    if (response)
      setErrState(() => response);
    else {
      const id = form.name;
      toast.success(msg('role-added', { id }));
      setIsModal(() => false);
      clearState();
    }
    setIsPending(() => false);
  };

  return (
    <>
      <div className="text-md">
        <TextButtom onClick={() => setIsModal(() => true)} underline>
          {title}
        </TextButtom>
      </div>

      {!!isModal && (
        <Modal
          title={title}
          style={{ maxWidth: '500px' }}
          onClose={() => {
            setIsModal(() => false);
            clearState();
          }}
        >
          <RoleItemForm
            isPending={isPending}
            form={form}
            handle={handle}
            handleRole={handleAddRole}
            errState={errState}
            btnTitle="Add Role"
          />
        </Modal>
      )}
    </>
  );
}

export default AddRoleLink;
